// DomainList.jsx
import React, { useState } from 'react';
import {
  Table,
  Box,
  SpaceBetween,
  TextFilter,
  StatusIndicator,
  Link
} from '@cloudscape-design/components';

const DomainList = ({ type, onSelect, setToolsOpen, domainsData }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [filterText, setFilterText] = useState('');

  // Transform domains data based on type
  const transformDomains = (domains) => {
    return domains.map(domain => ({
      name: domain.name,
      boundedContext: domain.context.bounded_context,
      domainType: domain.context.domain_type,
      confidence: 90, // You might want to calculate this based on your data
      // Calculate metrics based on domain type
      metrics: {
        entity: domain.domain_model.entities.length,
        operations: domain.business_operations.length,
        data: Object.keys(domain.data_characteristics.ownership.access_patterns).length
      }
    }));
  };

  const domains = transformDomains(domainsData.domains);

  const handleSelect = (item) => {
    // Find the full domain data to pass to the details panel
    const fullDomain = domainsData.domains.find(d => d.name === item.name);
    onSelect(fullDomain);
    setToolsOpen(true);
  };

  return (
    <SpaceBetween size="m">
      <TextFilter
        filteringText={filterText}
        onChange={({ detail }) => setFilterText(detail.filteringText)}
        placeholder="Find domains"
      />
      <Table
        columnDefinitions={[
          {
            id: 'name',
            header: 'Domain name',
            cell: item => (
              <Link onFollow={() => handleSelect(item)}>
                {item.name}
              </Link>
            ),
            sortingField: 'name'
          },
          {
            id: 'boundedContext',
            header: 'Bounded context',
            cell: item => item.boundedContext,
            sortingField: 'boundedContext'
          },
          {
            id: 'metrics',
            header: 'Metrics',
            cell: item => (
              type === 'entity' ? `${item.metrics.entity} entities` :
              type === 'operations' ? `${item.metrics.operations} operations` :
              `${item.metrics.data} data patterns`
            )
          },
          {
            id: 'type',
            header: 'Domain type',
            cell: item => (
              <StatusIndicator type={
                item.domainType === 'CORE' ? 'success' :
                item.domainType === 'SUPPORTING' ? 'info' :
                'warning'
              }>
                {item.domainType}
              </StatusIndicator>
            )
          },
          {
            id: 'confidence',
            header: 'Confidence',
            cell: item => `${item.confidence}%`,
            sortingField: 'confidence'
          }
        ]}
        items={domains.filter(domain =>
          domain.name.toLowerCase().includes(filterText.toLowerCase()) ||
          domain.boundedContext.toLowerCase().includes(filterText.toLowerCase())
        )}
        selectedItems={selectedItems}
        onSelectionChange={({ detail }) => setSelectedItems(detail.selectedItems)}
        selectionType="single"
        sortingDisabled={false}
        variant="container"
        stickyHeader
        stripedRows
      />
    </SpaceBetween>
  );
};

export default DomainList;
